/* eslint-disable class-methods-use-this */
/* eslint-disable import/extensions */
import Cookies from 'js-cookie'
import { Feature } from '../common'
import { COOKIE, PAGES } from '../../constants/GLOBAL_VARIABLE'
import { IIV_ERROR } from './enum'

class IIV extends Feature {
  constructor({ mainUrl }) {
    super({ namespace: 'iiv', enumKey: 'IIV' })
    this.mainUrl = mainUrl || 'https://signin.nexon.com'

    const {
      target = '',
      web_token: webToken = '',
      response = '',
      iiv_key: iivKey = '',
      error_code: errorCode = '',
      error_name: errorName = '',
      error_message: errorMessage = '',
      error_data: errorData = '{}',
    } = this.queryParam

    // from Client
    this.target = target
    this.webToken = webToken

    // from IIV (INSIGN-Front)
    this.response = response
    this.iivKey = iivKey
    this.errorCode = errorCode
    this.errorName = errorName
    this.errorMessage = errorMessage
    this.errorData = JSON.parse(errorData)

    this.platform = Cookies.get(COOKIE.PLATFORM_SELECTOR)

    console.debug('[IIV Instance]', this)
  }

  get isFromClient() {
    return !!this.target
  }

  get isFromIivPage() {
    return !!this.response
  }

  get hasSuccess() {
    return this.response === 'success' && this.iivKey
  }

  get hasError() {
    return this.response === 'fail' && (this.errorCode || this.errorName)
  }

  setIivCookie() {
    const cookie = {
      ...this.queryParamWithCookie,
      platform: this.platform, // TODO 제거 후 pages 에서도 selector.platform 으로 접근 필요
      temp_ifwt: this.webToken,
    }

    this.namespaceCookie.setCookie(cookie)
    console.log('[setIivCookie]', this.namespaceCookie.getCookie())
  }

  clearIivCookie() {
    this.namespaceCookie.clearCookie()
  }

  gotoIivPage() {
    this.navigateToUrlWithoutHistory(`${this.mainUrl}/${PAGES.IIV}`)
  }

  processIIV() {
    this.clearIivCookie()

    if (this.isFromClient) {
      this.setIivCookie()
      this.gotoIivPage()
      return
    }

    if (this.hasSuccess) {
      this.postSuccessMessage()
      return
    }
    this.postErrorMessage()
  }

  postErrorMessage() {
    const errorMessage = {
      success: false,
      error: {
        code: this.errorCode || IIV_ERROR.INIT_FAILED.code,
        name: this.errorName || IIV_ERROR.INIT_FAILED.name,
        message: this.errorMessage || IIV_ERROR.INIT_FAILED.message,
        data: this.errorData,
      },
    }
    this.postMessageToClient(errorMessage)
  }

  postSuccessMessage() {
    const successMessage = {
      success: true,
      data: {
        iivKey: this.iivKey,
      },
    }
    this.postMessageToClient(successMessage)
  }

  postMessageToClient(message) {
    let errorCount = 0
    console.log('[postMessageToClient]', message)

    try {
      window.parent.postMessage(message)
    } catch (error) {
      errorCount += 1
      console.warn('[Failed to send message to iframe. Ignore it if you are not using iframe.]')
    }
    try {
      window.opener.postMessage(message)
    } catch (error) {
      errorCount += 1
      console.warn('[Failed to send message to popup. Ignore it if you are not using popup.]')
    }

    if (errorCount >= 2) {
      console.error('[Failed to send message]')
    }
  }
}

export default IIV
